import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const eventThrottleUiNodeSpec: UiNodeSpec<'eventThrottle'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { max: 1, windowMs: 200 }, id: getUID(), kind: 'eventThrottle', disabled: false }),
    controls: getNodeCfg => ({
        max: ({ cfg: { kind: 'number', label: 'Max', min: 1 }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.max }),
        windowMs: ({ cfg: { kind: 'number', label: 'Window (ms)', min: 0 }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.windowMs }),
    }),
    inputs: () => ({ input: { socket: 'event', label: 'Input' } }),
    kindLabel: 'Event Throttle',
    nodeCategory: 'events',
    outputs: () => ({ output: { socket: 'event', label: 'Output' } }),
    validator: () => true,
};
